<template>
  <div class="cart-view">
    <FloatingHeader title="Carrinho" sbtitle="Finalize sua compra" :showHeader="true" :hideSearch="true"
      :toClear="'updateCurrentItemEdit'" :routeToBack="'event'" :hideArrowBack="isSingleProduct() && !isFullApp"></FloatingHeader>

    <div class="adicionados" v-if="getCart && getCart?.length">
      <h2>Itens adicionados</h2>
      <span @click="clearCartConfirm()">Limpar carrinho</span>
    </div>
    <div class="cart-items" v-if="getCart && getCart?.length">
      <div class="cart-item" v-for="(item, key) in getCart" :key="key">
        <div class="item-image">
          <img :src="getMockImage(item) || item.productImage || imgNotFound" alt="imagem produto">
        </div>
        <div class="item-details">
          <div class="name">
            <h2 v-text="item.productName"></h2>
            <span class='item-price' v-text="getItemPrice(item)"></span>
          </div>

          <div class="observations" v-if="item.observations && item.observations.length">
            <ul v-for="(obs, obsKey) in item.observations" :key="obsKey" v-text="obs.obsName"></ul>
          </div>

          <div class="combo-products" v-if="item.productCombo && item.productCombo.length">
            <ul v-for="(combo, comboKey) in item.productCombo" :key="comboKey">
              <div class="combo-item">
                <span v-text="combo.quantity || 1"></span>
                <span v-text="combo.subItemName"></span>
              </div>

              <div class="combo-item-obs" v-if="combo.observations && combo.observations.length">
                <ul v-for="(obs, obsKey) in combo.observations" :key="obsKey">
                  <li v-text="obs.subItemObsName"></li>
                </ul>
              </div>

              <!-- combo do combo -->
              <div class="combo-do-combo-item" v-if="combo.subItemProductGroups?.length > 0 && combo.choosen">
                <div v-for="(subItemFather, subItemKey) in combo.choosen" :key="subItemKey">
                  <ul v-for="(subItemConcrete, subItemConcreteKey) in subItemFather" :key="subItemConcreteKey"
                    class="combo-do-combo-subitem">
                    <li v-text="subItemConcrete.subItemName"></li>

                    <ul v-for="(subItemObs, subItemObsKey) in subItemConcrete.observations" :key="subItemObsKey">
                      <li v-text="subItemObs.subItemObsName"></li>
                    </ul>
                  </ul>
                </div>
              </div>
            </ul>
          </div>

          <div class="edit-and-qtt">
            <span class='edit' @click="editItem(item)">
              <fa :icon="['fas', 'pen-to-square']" class='edit-item'></fa>
            </span>
            <QuantityControl class="qtt" :quantity="item?.quantity || 0" :disabledMinus="disabledMinus(item)" :trashIcon="true"
              @circleBtnRemove="decreaseAddQtty(item, key)" @circleBtnAdd="increaseAddQtty(key)">
            </QuantityControl>
          </div>
        </div>

      </div>
    </div>

    <div class="not-found" v-else>
      <h2>Seu carrinho está vazio</h2>
      <p>Adicione itens ao carrinho para continuar</p>
      <p v-if="!isFullApp">Ou escaneie o QR Code do seu pedido</p>
    </div>

    <div class="checkout" v-if="getCart && getCart?.length">
      <div class="total-price">
        <h2>Total a pagar:</h2>
        <span>{{ getCartTotalPrice() }}</span>
      </div>

      <DefaultButton :text="'Finalizar compra'" @defaultBtnClick="goToCheckout()" :large="true">
      </DefaultButton>

      <span class="buy-more" @click="$router.push('event')" v-if="isFullApp || !isSingleProduct()">
        Continuar comprando
      </span>
    </div>
  </div>

  <ModalInfo :modalOpen="deleteProdModalOpen" @actionTrue="confirmDeleteProduct" @actionFalse="closeDeleteModal">
  </ModalInfo>

  <ModalInfo :modalOpen="clearCartModalOpen" @actionTrue="clearCart" @actionFalse="closeClearCartModal"></ModalInfo>
</template>
<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import { mapActions, mapGetters } from 'vuex'
import Util from '@/assets/libs/util'
import QuantityControl from '@/components/QuantityControl.vue'
import CartController from '@/assets/controllers/CartController'
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import ProductController from '@/assets/controllers/ProductController'

export default {
  name: 'CartView',
  components: {
    FloatingHeader,
    QuantityControl,
    DefaultButton,
    ModalInfo
  },
  data () {
    return {
      deleteProdModalOpen: false,
      keyProductToDelete: null,
      clearCartModalOpen: false,
      imgNotFound: require('@/assets/mock/prodImg/placeholder.svg')
    }
  },
  computed: {
    ...mapGetters(['getCart', 'getMenu', 'isFullApp'])
  },
  methods: {
    ...mapActions(['increaseQttyCart', 'decreaseQttyCart', 'showModalInfo', 'updateCurrentItemEdit']),
    getMockImage (prod) {
      try {
        return require(`@/assets/mock/prodImg/${prod.productCode}.png`)
      } catch (error) {
        return null
      }
    },
    getItemPrice (item) {
      return this.formatMoney(item.totalItemPrice)
    },
    formatMoney (value) {
      return Util.formatMoney(value)
    },
    disabledMinus: function (prod) {
      return prod.subItemProductGroups?.length > 0 // && prod.quantity > 0
    },
    decreaseAddQtty: function (prod, key) {
      if (prod.quantity > 1) {
        this.decreaseQttyCart(key)
      } else {
        this.deleteProdModalOpen = true
        this.keyProductToDelete = key
        this.showModalInfo({
          type: 'defaultDialog',
          text: `Deseja remover ${prod.productName} do carrinho?`,
          icon: 'fa-solid fa-trash'
        })
      }
    },
    decreaseQttyCart: function (key) {
      this.$store.dispatch('decreaseQttyCart', key)
    },
    increaseAddQtty: function (key) {
      this.increaseQttyCart(key)
    },
    getCartTotalPrice: function () {
      return this.formatMoney(CartController.calculateTotalPrice())
    },
    closeDeleteModal: function () {
      this.deleteProdModalOpen = false
      this.keyProductToDelete = null
    },
    closeClearCartModal: function () {
      this.clearCartModalOpen = false
    },
    confirmDeleteProduct: function () {
      this.$store.dispatch('deleteProductCart', this.keyProductToDelete)
      this.deleteProdModalOpen = false

      if (this.getCart.length === 0) {
        if (this.isSingleProduct() && !this.isFullApp) {
          return this.$router.push('/read-qrcode')
        }

        this.$router.push('/event')
        Util.showWarningNotification({
          title: 'Carrinho vazio',
          text: 'Adicione itens para continuar'
        })
      }
    },
    editItem: function (prod) {
      prod.edited = true
      this.updateCurrentItemEdit(ProductController.ajustProductToOpen(JSON.parse(JSON.stringify(prod))))
      this.$router.push('productitem')
    },
    goToCheckout: function () {
      if (this.getCart.length === 0) {
        Util.showWarningNotification({
          title: 'Carrinho vazio',
          text: 'Adicione itens para continuar'
        })
        return
      }
      this.$router.push('/checkout')
    },
    clearCart: function () {
      CartController.clearCart()
      if (this.isSingleProduct() && !this.isFullApp) {
        return this.$router.push('/read-qrcode')
      }
      this.$router.push('/event')
      Util.showSuccessNotification({
        title: 'Carrinho limpo',
        text: 'Adicione itens para continuar'
      })
    },
    clearCartConfirm: function () {
      this.showModalInfo({
        type: 'defaultDialog',
        text: 'Deseja limpar o carrinho?',
        icon: 'fa-solid fa-trash'
      })
      this.clearCartModalOpen = true
    },
    isSingleProduct () {
      return true

      // Comentado pela demanda da Sodexo: alunos nao terem acesso ao cardapio dos funcionarios

      // if (this.isFullApp) return false

      // const menu = this.getMenu
      // const cart = this.getCart

      // if (!menu?.groups?.length || !cart?.length) return false

      // const allProducts = menu.groups.flatMap(group => group.products)

      // // verifica se só há 1 produto no menu e no carrinho
      // const isSingleProduct = allProducts.length === 1
      // return isSingleProduct
    }
  },
  mounted () {
    if (!this.isFullApp) {
      const storedCart = JSON.parse(localStorage.getItem('app_cart'))

      // carrinho expirado - força o usuário a ler o QR Code novamente
      if (!storedCart || storedCart.length === 0) {
        this.$router.push('read-qrcode')
        Util.showWarningNotification({
          title: 'Carrinho vazio',
          text: 'Leia o QR Code para continuar'
        })
      }
    }
  }
}
</script>

<style lang="less">
.cart-view {
  position: relative;
  display: block;
  padding: 65px 20px 170px 20px;

  .adicionados {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      font-size: 1rem;
      margin: 20px 0 15px 0;
    }

    span {
      font-size: 1rem;
      color: var(--primaryColor);
      cursor: pointer;
    }
  }

  .cart-items {
    margin-bottom: 50px;

    .cart-item {
      display: grid;
      grid-template-columns: 1fr 3fr;
      padding: 10px;
      margin: 15px 0;
      border-bottom: 1px solid #ccc;

      .item-image {
        width: 80px;
        height: 80px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .item-details {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-around;
        padding: 0 10px;

        .name {
          display: flex;
          justify-content: space-between;
          font-size: 1rem;
          margin-right: 2px;

          h2 {
            margin: 0;
            font-size: 1rem;
          }

          .edit-item {
            padding-top: 5px;
            color: #666;
            font-size: 1rem;
            cursor: pointer;
          }

          .item-price {
            font-weight: 800;
            color: var(--primaryColor);
            font-size: 1rem;
          }
        }

        .observations {
          ul {
            font-size: 0.8rem;
            color: #666;
            margin: 0;
            padding: 0;
            margin: 10px 0;
          }
        }

        .combo-products {
          ul {
            font-size: 0.8rem;
            color: #666;
            margin: 0;
            padding: 0;
          }

          .combo-item {
            display: flex;
            gap: 5px;
            margin: 5px 0;

            span {
              font-size: 0.8rem;
              color: #666;

              &:first-child {
                font-weight: bold;
                background: #f5f5f5;
                color: #666 !important;
                padding: 5px;
                border-radius: 5px;
                font-size: 0.6rem;
                height: 10px;
                width: 16px;
                color: white;
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
          }

          .combo-item-obs {
            ul {
              font-size: 0.8rem;
              color: #666;
              padding: 0;
            }

            li {
              margin-left: 40px;
            }
          }

          .combo-do-combo-item {
            ul {
              font-size: 0.8rem;
              color: #666;
              padding: 0;
            }

            li {
              margin-left: 40px;
            }

            .combo-do-combo-subitem {
              ul {
                list-style-type: disc;
                list-style-position: inside;
              }

            }
          }
        }

        .edit-and-qtt {
          display: flex;
          justify-content: space-between;
          gap: 10px;
          align-items: center;
          margin-top: 20px;

          .edit {
            color: var(--primaryColor);
            font-size: 1rem;
            background: var(--primaryColorTransparent);
            padding: 5px 10px;
            border-radius: 5px;
            height: 25px;
          }

          .qtt {
            width: 10px;
            background: var(--primaryColorTransparent);
            border-radius: 5px;
            font-size: 1rem;
            min-height: 35px;

            span {
              font-size: 1rem;
              color: var(--primaryColor);
              background: #fff;
              min-height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
    }
  }

  .not-found {
    margin: 25px 0;
    text-align: center;

    h2 {
      font-size: 1.5rem;
      margin: 0;
    }

    p {
      font-size: 1rem;
      color: #666;
    }
  }

  .checkout {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background: white;
    bottom: 0;
    width: -webkit-fill-available;
    left: 0;
    animation: upper-in 0.4s;
    padding: 10px 0 40px 0;
    filter: drop-shadow(2px 4px 6px black);

    .total-price {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin: 15px;

      h2 {
        font-size: 1rem;
        margin: 0;
        padding-left: 20px;
        color: #666;
      }

      span {
        font-size: 1rem;
        font-weight: 600;
        padding-right: 20px;
      }
    }

    button {
      display: block;
      min-width: 300px !important;
      height: 55px !important;
      margin: 5px !important;
      border: none;
      background: var(--primaryColor);
      color: white;
    }

    .buy-more {
      font-size: 1rem;
      color: var(--primaryColor);
      margin: 10px 0;
    }
  }
}
</style>
